import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getJSON } from '../util';

export function* fetch({ payload }) {
    let response;
    const url = '/api/daily-horoscope';
    const user = yield select(state => state.user);
    const signs = yield select(state => state.zodiac && state.zodiac.signs);

    if (user.logged_in && !payload.sign) {
        payload.sign = signs[user.default_sign - 1].name;
    }

    try {
        response = yield call(getJSON, url, payload);
    } catch (e) {
        return;
    }

    response.loaded = true;

    yield put({type: 'horoscope:update', payload: response});
}

export function* root() {
    yield takeEvery('horoscope:require', fetch);
}